module.exports = __webpack_public_path__ + "568d302aa1bd302225d2f56ba8083d79.webp";